export const YEAR_ONLY_CUTOFF_YEAR = 600
export const ABBR_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/* Some handy magnitudes names See also https://en.wikipedia.org/wiki/Time and https://en.wikipedia.org/wiki/Category:Units_of_time

decagigennium = 10,000,000,000 years (10 billion years)
gigaannum = 1,000,000,000 years (1 billion years)
decamegennium = 10,000,000 (10 million years)
half-decamegennium = 5,000,000 (5 million years)
megennium = 1,000,000 years (million years)
centamillenium 100,000 years
half-centamillenium 50,000 years
decamillenium = 10,000 years
half-decamillenium = 5,000 years
millennium = 1000 years
half-millennium = 500 years
century = 100 years
half-century = 50 years
score = 20 years
decade = 10 years
lustrum or half-decade = 5 years
quadrennium or olympiad = 4 years
triennium = 3 years
and biennium = 2 years

*/

// The scale supported magnitudes
export const MAGNITUDES = {
  millisecond: 1,
  second: 1000,
  minute: 60000,
  hour: 3600000,
  day: 86400000,
  week: 604800000,
  month: 2592000000,
  halfyear: 31449600000 / 2,
  year: 31449600000,
  halfdecade: 157248000000,
  decade: 314496000000,
  halfcentury: 1572480000000,
  century: 3144960000000,
  halfmillenium: 3144960000000 * 5,
  millenium: 3144960000000 * 10,
  halfdecamillenium: 3144960000000 * 50,
  decamillenium: 3144960000000 * 100,
}
